module.exports = __webpack_public_path__ + "img/SummaryBanner.9a40f0ce.png";